import { render, staticRenderFns } from "./KpiEditor.vue?vue&type=template&id=3b79dd44&scoped=true"
import script from "./KpiEditor.vue?vue&type=script&lang=js"
export * from "./KpiEditor.vue?vue&type=script&lang=js"
import style0 from "./KpiEditor.vue?vue&type=style&index=0&id=3b79dd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79dd44",
  null
  
)

export default component.exports